import { Component, OnInit, OnDestroy } from '@angular/core';
import { BankAcc } from '../../../../../models/BankAcc';
import { Code } from '../../../../../models/Code';

import { AdminService } from '../../../../../services/Admin.service';
import { Router, ActivatedRoute } from '@angular/router';

import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../../shared-components/busy-indicator/busy-indicator.component';

@Component({
  selector: 'app-update-bank-account',
  templateUrl: './update-bank-account.component.html',
  styleUrls: ['./update-bank-account.component.scss']
})
export class UpdateBankAccountComponent implements OnInit, OnDestroy {
  public bankAccModel: BankAcc;
  public countryList: Code[];
  public  accountTypeList: Code[];
  public errorMsg: string;
  public successMsg: string;
  private currentYear: number;
  private index: number;
  private BAID: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  private alive = true;

  constructor(private adminSvc: AdminService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.route.params
    .takeWhile(() => this.alive)
    .subscribe( params => {
      this.BAID = params['id'];
    });
  }

  ngOnInit() {
    this.bankAccModel = new BankAcc();
    this.getaccountTypes();
    this.getCountries();
    this.getBankAccountDetails();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  getCountries() {
    this.adminSvc.getCountries()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.countryList = data;
    });
  }

  getaccountTypes() {
    this.adminSvc.getBankAccountTypes()
    .takeWhile(() => this.alive)
    .subscribe(data => {
      this.accountTypeList = data;
    });
  }

  onCancel() {
    this.router.navigate(['/pages/client/my-settings/bank-accounts']);
  }

  onSubmit(frmAddBA: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
       this.adminSvc.updateBankAccountDetails(this.bankAccModel)
       .takeWhile(() => this.alive)
       .subscribe(
      data => {
                this.spinner.hide();
                if (data === true) {
                  this.successMsg = 'Bank Account ' + this.bankAccModel.AccountNickname + ' updated successfully.';
                  this.showFailConfirmation = false;
                  this.showSuccessConfirmation = true;
                } else {
                  this.successMsg = null;
                  this.errorMsg = 'Failed to update Bank account.';
                  this.showFailConfirmation = true;
                  this.showSuccessConfirmation = false;
                }
            },
      err => {
          this.spinner.hide();
          this.successMsg = null;
          this.errorMsg = err;
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
        }
    );
   // window.scrollTo(0, 0);
  }

  getBankAccountDetails() {
    this.adminSvc.getBankAccountDetails(this.BAID)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.bankAccModel = data;
                this.bankAccModel.BAID = this.BAID;
            },
      err => {
          this.successMsg = null;
          this.errorMsg = err;
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
      }
    );
  }

  goToMyContract(event) {
    this.router.navigate(['/pages/client/my-settings/bank-accounts']);
  }

  close(event) {
    this.showSuccessConfirmation = false;
    this.showFailConfirmation = false;
  }

  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-settings/bank-accounts/update-bank-account/update-bank-account.component.ts